"use strict";
var ajaxUtils_1 = require("./ajaxUtils");
var metrikaUtils_1 = require("./metrikaUtils");
var _ = require("lodash");
var placementsUtils_1 = require("./placementsUtils");
var scriptjs = require("scriptjs");
var MerchantUtils = (function () {
    function MerchantUtils() {
    }
    MerchantUtils.getRewardTitleOptions = function () {
        return [
            "Отличная книга!",
            "Прекрасная работа",
            "Качественная и достойная вещь!",
            "Потрясающе и интригующе",
            "Мне очень нравится!",
            "Спасибо за работу, автор",
            "Потрясающе!",
            "Рекомендую!",
            "Спасибо за ваш труд!",
            "Очень увлекательно!",
            "Хорошее произведение!",
            "Восхитительная работа!",
            "Просто ОГОНЬ"
        ];
    };
    MerchantUtils.initButton = function (buyButton, mode) {
        if (buyButton.processing()) {
            buyButton.errorMessages(["Подождите, идет загрузка настроек оплаты. Если эта ошибка повторяется, обновите страницу."]);
            return $.Deferred().reject();
        }
        buyButton.processing(true);
        return ajaxUtils_1.AjaxUtils.apiV2Get("merchant/pay-setting?saveCard=true&balance=true&mode=" + mode)
            .done(function (result) {
            buyButton.processing(false);
            if (result.status !== "Success") {
                buyButton.errorMessages(["Ошибка при получении настроек оплаты!", result.message]);
                return $.Deferred().reject();
            }
            var paySettings = result.data;
            buyButton.balance = paySettings.balance;
            buyButton.saveCard = paySettings.saveCard;
            buyButton.enabledPayMethods = [];
            for (var i = 0; i < paySettings.payMethods.length; i++) {
                var payMethod = paySettings.payMethods[i];
                if (!payMethod.isEnabled)
                    continue;
                buyButton.enabledPayMethods.push(payMethod.id);
                switch (payMethod.id) {
                    case "PaySelection":
                        buyButton.paySelectionMin = payMethod.minAmount;
                        buyButton.paySelectionCommission = payMethod.commission;
                        break;
                    case "CloudPayments":
                        buyButton.cloudPaymentsMin = payMethod.minAmount;
                        buyButton.cloudPaymentsCommission = payMethod.commission;
                        break;
                    case "PayAnyWay":
                        buyButton.payAnyWayMin = payMethod.minAmount;
                        buyButton.payAnyWayCommission = payMethod.commission;
                        break;
                    case "Robokassa2":
                        buyButton.robokassa2Commission = payMethod.commission;
                        break;
                    case "Unitpay":
                        buyButton.unitpayMin = payMethod.minAmount;
                        buyButton.unitpayCommission = payMethod.commission;
                        break;
                }
            }
            if (buyButton.workStatus === 2) {
                buyButton.rewardTitleOptions.push("Жду продолжения!");
                buyButton.rewardTitleOptions.push("Поскорее бы проду... :-)");
                buyButton.rewardTitleOptions.push("С нетерпением жду каждую главу!");
            }
            if (buyButton.saveCard !== null) {
                buyButton.savePaymentMethod(buyButton.saveCard);
            }
            else {
                buyButton.savePaymentMethod(true);
            }
            var updateSaveCard = function (value) {
                if (buyButton.processing())
                    return;
                buyButton.processing(true);
                ajaxUtils_1.AjaxUtils.apiV2Post("account/save-card", { saveCard: value })
                    .done(function (result) {
                    buyButton.processing(false);
                    if (result.status === "Success") {
                        buyButton.saveCard = value;
                    }
                    else {
                        buyButton.errorMessages([result.message]);
                    }
                });
            };
            buyButton.savePaymentMethod.subscribe(function (value) {
                if (buyButton.stage() === "askToSavePaymentMethod") {
                    updateSaveCard(value);
                }
            });
            buyButton.savePaymentMethodDontAsk.subscribe(function (value) {
                if (buyButton.stage() === "askToSavePaymentMethod") {
                    if (value) {
                        updateSaveCard(buyButton.savePaymentMethod());
                    }
                    else {
                        updateSaveCard(null);
                    }
                }
            });
            // Если покупка произведения - отправляем трекинг в РРГ
            if (mode == "work") {
                placementsUtils_1.default.trackClickBuy(buyButton.workId);
            }
        });
    };
    MerchantUtils.goToStage = function (stage, mode, buyButton) {
        if (stage !== "startBuyingWork" && buyButton.validation !== undefined && !buyButton.validation.isValid()) {
            console.log(buyButton.validation.errors());
            buyButton.validation.errors.showAllMessages();
            return;
        }
        ;
        try {
            switch (stage) {
                case "selectPaymentMethod":
                    switch (mode) {
                        case "work":
                        case "gift":
                            metrikaUtils_1.default.reachGoal("buyWork");
                            break;
                        case "workWithReward":
                            metrikaUtils_1.default.reachGoal("buyWorkWithReward");
                            break;
                        case "reward":
                            metrikaUtils_1.default.reachGoal("buyReward");
                            break;
                    }
                    break;
                case "promoCode":
                    metrikaUtils_1.default.reachGoal("promoCodeForm");
                    break;
            }
        }
        catch (ex) { }
        if (buyButton.mode() !== mode) {
            buyButton.mode(mode);
        }
        buyButton.errorMessages([]);
        buyButton.stage(stage);
    };
    MerchantUtils.checkSavedBankCards = function (el, payMethod, buyButton, app) {
        if (buyButton.processing())
            return;
        buyButton.processing(true);
        var $loadingIndicator = $("<div class=\"loading-indicator\"><div class=\"la-timer la-dark\">" +
            "<div></div></div></div>");
        ajaxUtils_1.AjaxUtils.apiV2Get("merchant/saved-cards?payMethod=" + payMethod)
            .done(function (result) {
            if (result.status === "Success" && result.data && result.data.length > 0) {
                buyButton.errorMessages([]);
                var options = _.map(result.data, function (x) {
                    return {
                        id: x.id,
                        cardType: x.cardType,
                        expiryMonth: x.expiryMonth,
                        expiryYear: x.expiryYear,
                        title: x.first6.substring(0, 4) + " " + x.first6.substring(4) + "XX XXXX " + x.last4
                    };
                });
                options.push({
                    id: null,
                    cardType: "New",
                    title: "Другая"
                });
                buyButton.bankcardOptions(options);
                buyButton.selectedBankCard(options[0]);
                buyButton.stage("fastPayment");
            }
            else {
                var isBlocked = app.yaKassaBlocked;
                if (isBlocked) {
                    buyButton.savePaymentMethod(false);
                }
                else {
                    if (buyButton.saveCard !== null) {
                        buyButton.savePaymentMethod(buyButton.saveCard);
                    }
                }
                setTimeout(function () {
                    if (buyButton.saveCard !== null || isBlocked) {
                        buyButton.selectPayMethod(el, payMethod);
                    }
                    else {
                        buyButton.stage("askToSavePaymentMethod");
                    }
                }, 0);
            }
            $loadingIndicator.remove();
            $(".pay-method > a").each(function (i, el) { $(el).parent().removeClass("temp-disabled"); });
            buyButton.processing(false);
        });
    };
    MerchantUtils.deleteSavedCard = function (buyButton) {
        if (buyButton.processing())
            return;
        buyButton.processing(true);
        var card = buyButton.selectedBankCard();
        ajaxUtils_1.AjaxUtils.apiV2Post("merchant/delete-saved-card", { id: card.id })
            .done(function (result) {
            buyButton.processing(false);
            if (result.status === "Success") {
                buyButton.bankcardOptions.remove(card);
            }
            else {
                buyButton.errorMessages([result.message]);
            }
        });
    };
    MerchantUtils.payMethodEnabled = function (buyButton, payMethods) {
        if (buyButton.enabledPayMethods && Array.isArray(buyButton.enabledPayMethods)) {
            for (var i = 0; i < payMethods.length; i++) {
                if (buyButton.enabledPayMethods.indexOf(payMethods[i]) !== -1) {
                    return true;
                }
            }
        }
        return false;
    };
    MerchantUtils.createOder = function (el, payMethod, buyButton, successCallback) {
        var _this = this;
        if (buyButton.processing())
            return;
        if (!buyButton.payMethodEnabled(payMethod))
            return;
        buyButton.processing(true);
        $(".pay-method > a").each(function (i, el) { $(el).parent().addClass("temp-disabled"); });
        if ($(el).is("a")) {
            var $loadingIndicator = $("<div class=\"loading-indicator\"><div class=\"la-timer la-dark\">" +
                "<div></div></div></div>");
            $loadingIndicator.appendTo(el);
        }
        var mode = buyButton.mode();
        var savePaymentMethod = buyButton.savePaymentMethod();
        if (payMethod !== "CreditCard" && payMethod !== "YaKassa" && payMethod !== "SberPay" && payMethod !== "Tinkoff" && payMethod !== "TinkoffCard") {
            savePaymentMethod = false;
        }
        var orderData = {
            itemId: mode == "series" ? buyButton.seriesId : buyButton.workId,
            payMethod: payMethod,
            savePaymentMethod: savePaymentMethod,
            mode: mode,
            price: buyButton.price
        };
        if (mode === "workWithReward" || mode === "reward" || mode === "wallet" || mode === "advertise") {
            orderData.rewardPrice = buyButton.rewardValue();
            orderData.rewardTitle = buyButton.rewardTitle();
        }
        if (mode == 'aiVoiceover') {
            orderData.textLength = buyButton.textLength;
        }
        var selectedCard = buyButton.selectedBankCard();
        if (selectedCard && selectedCard.cardType !== "New") {
            orderData.savedCardId = selectedCard.id;
        }
        ajaxUtils_1.AjaxUtils.apiV2Post("merchant/create-order", orderData)
            .done(function (result) {
            if (result.status === "Success") {
                try {
                    metrikaUtils_1.default.reachGoal("createOrder", {
                        order_price: buyButton.price,
                        currency: "RUB",
                        orderId: result.data.orderId,
                        workId: buyButton.workId,
                        seriesId: buyButton.seriesId,
                        workStatus: buyButton.workStatus,
                        workTitle: buyButton.workTitle,
                        payMethod: payMethod,
                        savePaymentMethod: savePaymentMethod
                    });
                }
                catch (ex) {
                    console.log(ex);
                }
                try {
                    if (successCallback)
                        successCallback(buyButton, result);
                }
                catch (ex) {
                    console.log(ex);
                }
                setTimeout(function () {
                    var method = (result.data.method || "post").toLowerCase();
                    if (method === "get") {
                        window.location.href = result.data.url;
                        return;
                    }
                    if (method === "widget") {
                        if (payMethod === "CloudPayments") {
                            _this.processCloudPaymentsOrder(result.data, buyButton);
                            return;
                        }
                    }
                    if (method === "post") {
                        var $form = $("<form action=\"" + result.data.url + "\" method=\"post\" accept-charset=\"UTF-8\" style=\"display: none\">");
                        if (result.data.formData) {
                            _.each(JSON.parse(result.data.formData), function (v, k) {
                                if (_.isString(v)) {
                                    var $input = $("<input/>", {
                                        name: k,
                                        value: v
                                    });
                                    $form.append($input);
                                }
                                else {
                                    _.each(v, function (arr) {
                                        var $input = $("<input/>", {
                                            name: k,
                                            value: arr
                                        });
                                        $form.append($input);
                                    });
                                }
                            });
                        }
                        $("body").append($form);
                        $form.submit();
                    }
                }, 1000);
            }
            else {
                buyButton.errorMessages([result.message]);
            }
            setTimeout(function () {
                if ($(el).is("a")) {
                    $loadingIndicator.remove();
                }
                $(".pay-method > a").each(function (i, el) { $(el).parent().removeClass("temp-disabled"); });
                buyButton.processing(false);
                if ($(el).is("button")) {
                    $(el).removeClass("is-loading");
                    $(el).removeAttr("disabled");
                }
            }, 1000);
        });
    };
    MerchantUtils.processCloudPaymentsOrder = function (data, buyButton) {
        scriptjs(["https://widget.cloudpayments.ru/bundles/cloudpayments.js"], function () {
            var widget = new cp.CloudPayments();
            widget.pay('charge', {
                publicId: data.data.publicId,
                description: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0437\u0430\u043A\u0430\u0437\u0430 #" + data.orderId + " \u043D\u0430 Author.Today",
                amount: data.data.amount,
                currency: "RUB",
                accountId: data.data.userId.toString(),
                invoiceId: data.orderId.toString(),
                email: data.data.email,
                skin: 'mini',
                retryPayment: false,
                autoClose: 3,
                configuration: {
                    common: {
                        successRedirectUrl: data.data.successUrl,
                        failRedirectUrl: data.data.failUrl
                    }
                }
            }, {
                onSuccess: function (options) {
                    console.log("CloudPayments: onSuccess");
                    try {
                        buyButton.modal.hide();
                    }
                    catch (e) { }
                    window.location.href = data.data.successUrl;
                },
                onFail: function (reason, options) {
                    console.error("CloudPayments: onFail: ", reason);
                    if (!(reason) || reason === "User has cancelled") {
                        // Пользователь отменил покупку или закрыл окно
                        return;
                    }
                    buyButton.errorMessages([
                        "Произошла ошибка. Пожалуйста, немного подождите и попробуйте еще раз. " +
                            "Если ошибка повторяется - сообщите об этом в службу поддержки.",
                        ("\u041F\u0440\u0438\u0447\u0438\u043D\u0430: " + reason)
                    ]);
                },
                onComplete: function (paymentResult, options) {
                }
            });
        });
    };
    ;
    MerchantUtils.selectReward = function (value, buyButton) {
        if (value === "custom") {
            buyButton.isCustomRewardValue(true);
        }
        else {
            buyButton.rewardValue(value);
            buyButton.isCustomRewardValue(false);
        }
    };
    MerchantUtils.selectRewardTitle = function (index, buyButton) {
        var title = buyButton.rewardTitleOptions[index];
        if (buyButton.previousRandomTitles.indexOf(title) !== -1) {
            buyButton.selectRandomRewardTitle();
        }
        else {
            buyButton.rewardTitle(title);
            buyButton.previousRandomTitles = buyButton.previousRandomTitles.slice(0, 5);
        }
    };
    MerchantUtils.submitPromoCode = function (buyButton, successCallback) {
        if (buyButton.validation !== undefined && !buyButton.validation.isValid()) {
            buyButton.validation.errors.showAllMessages();
            return;
        }
        ;
        buyButton.errorMessages([]);
        buyButton.processing(true);
        ajaxUtils_1.AjaxUtils.apiV2Post("merchant/promo-code", {
            code: buyButton.promoCode(),
            workId: buyButton.workId
        })
            .done(function (result) {
            buyButton.processing(false);
            if (result.status === "Success") {
                if (successCallback)
                    successCallback(buyButton);
                try {
                    metrikaUtils_1.default.reachGoal("promoCodeActivation");
                }
                catch (ex) { }
                try {
                    buyButton.reloadPage();
                }
                catch (ex) {
                    buyButton.fullReloadPage();
                }
            }
            else {
                buyButton.errorMessages([result.message]);
            }
        });
    };
    return MerchantUtils;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MerchantUtils;
//# sourceMappingURL=merchantUtils.js.map